function sjcb_escape(string) {
	return string
		.replace(/&/g, "&amp;")
		.replace(/</g, "&lt;")
		.replace(/>/g, "&gt;")
		.replace(/"/g, "&quot;")
		.replace(/'/g, "&#39;");
}

function init_sjcb_UTM(){
	const utm_params = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_adgroup', 'utm_term', 'utm_id'];
	const search_params = new URLSearchParams(window.location.search);
	window.dataLayer = window.dataLayer || [];

	search_params.forEach((value, key) => {
		if(utm_params.includes(key)){

			sessionStorage.setItem('sjcb_' + key, value );

			dataLayer.push({
				event: 'sjcb_' + key,
				utm_param: {
					key: key,
					value: value,
				}
			});
		}
	});

	apply_sjcb_UTM();
}

function apply_sjcb_UTM(){
	const keys = {
		utm_source : 'uTMSource',
		utm_medium : 'uTMMedium',
		utm_campaign : 'uTMCampaign',
		utm_adgroup : 'uTMAdgroup',
		utm_term : 'uTMTerm',
		utm_id : 'uTMId'
	};
	
	for(const [key, value] of Object.entries(keys)){
		const key_field_elements = Array.from(document.querySelectorAll('.' + sjcb_escape(value)));

		if(key_field_elements.length < 1) continue;

		const key_value = sessionStorage.getItem('sjcb_' + sjcb_escape(key));

		if(typeof key_value === 'undefined' || key_value === null || key_value === '')continue;

		key_field_elements.forEach( (key_field_element) => {
			key_field_element.value = sjcb_escape(key_value);
		});
	};
}

function clear_sjcb_UTM(){
	const keys = {
		utm_source : 'uTMSource',
		utm_medium : 'uTMMedium',
		utm_campaign : 'uTMCampaign',
		utm_adgroup : 'uTMAdgroup',
		utm_term : 'uTMTerm',
		utm_id : 'uTMId'
	};

	for(const [key, value] of Object.entries(keys)){
		const key_item = sessionStorage.getItem('sjcb_' + key);

		if(typeof key_item !== 'undefined' || key_item !== null || key_item !== ''){
			sessionStorage.removeItem('sjcb_' + key);
		}

		const key_field_elements = Array.from(document.querySelectorAll('.' + sjcb_escape(value)));

		if(key_field_elements.length < 1) return;

		key_field_elements.forEach( (key_field_element) => {
			key_field_element.value = '';
		});
	};
}

window.addEventListener('OneTrustGroupsUpdated', event => {
	if(event.detail.includes('C0004')){
		init_sjcb_UTM();
	} else{
		clear_sjcb_UTM();
	}
});

window.addEventListener('load' , (e) => {
	if(OnetrustActiveGroups.includes('C0004')){
		init_sjcb_UTM();
	} else{
		clear_sjcb_UTM();
	}
});